import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppBootstrap } from 'src/contexts/app-bootstrap-context';
import { paths } from 'src/routes/paths';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from 'src/components/ui/dialog';

import { APP_TOUR } from './tours/app-tour';
import { getTourRecord, setTourRecord } from './tour-storage';
import { useTour } from './tour-provider';

// Offered once, on Daily Overview, to a merchant who has finished onboarding
// and has no stored choice for this tour yet. AppLayout remounts on every
// cross-route navigation (see tour-store.ts), so this component re-mounts
// with fresh state each time Daily Overview is visited — the storage check
// below is what makes a stored choice stick permanently across those remounts.
export function TourWelcomeDialog() {
  const location = useLocation();
  const { startTour, active } = useTour();
  const { validationComplete, onboardingState } = useAppBootstrap();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    // `!active` matters on remount: a running tour writes no storage record, so
    // navigating back to Daily Overview mid-tour would otherwise re-offer on top
    // of the tour it belongs to.
    const eligible =
      !active &&
      location.pathname === paths.dailyOverview.root &&
      validationComplete &&
      onboardingState != null &&
      onboardingState.isNew === false &&
      getTourRecord(APP_TOUR.id) === null;

    if (eligible) {
      setOpen(true);
    }
  }, [active, location.pathname, validationComplete, onboardingState]);

  const dismiss = () => {
    setTourRecord(APP_TOUR.id, 'dismissed', APP_TOUR.version);
    setOpen(false);
  };

  const takeTour = () => {
    setOpen(false);
    startTour(APP_TOUR.id);
  };

  return (
    <Dialog open={open} onOpenChange={(next) => (!next ? dismiss() : undefined)}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Want a quick tour?</DialogTitle>
          <DialogDescription>
            See how Athory works for you: the morning check-in, recommendations that become purchase
            orders in two clicks, and the three setup actions that unlock full intelligence. You can
            restart it anytime from the user menu.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={dismiss}>
            Maybe later
          </Button>
          <Button onClick={takeTour}>Take the tour</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
